import { portalRoles } from '../enums/portalRoles';

export const isGuardian = institutionProfile => institutionProfile.role === portalRoles.GUARDIAN;
